import React from 'react';
import './journalEntry.scss';
import pdfIcon from '../../img/pdf.png';

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  Lookup,
  Editing,
  Selection,
  Summary,
  Toolbar,
  Format,
  SearchPanel
} from 'devextreme-react/data-grid';

import { useState, useEffect } from "react";
import { useAuth } from  '../../contexts/auth';
import { DateBox } from 'devextreme-react/date-box'; 
import {Logout, IsRole_Admin, IsRole_Manager, IsRole_Designer,IsRole_SalesManager, getQuarterDates} from '../../globals';
import {Item} from 'devextreme-react/form';

import { jsPDF } from 'jspdf';
import { exportDataGrid } from 'devextreme/pdf_exporter';
const exportFormats = ['pdf'];

// function getQuarterDates() {
//   const now = new Date();
//   const currentMonth = now.getMonth();
//   const quarter = Math.floor(currentMonth / 3);
//   const startMonth = quarter * 3;

//   const startDate = new Date(now.getFullYear(), startMonth, 1);
//   const endDate = new Date(now.getFullYear(), startMonth + 3, 0);

//   return {
//     start: formatDateLocal(startDate),
//     end: formatDateLocal(endDate),
//   };
// }

// function formatDateLocal(date) {
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const day = String(date.getDate()).padStart(2, "0");
//   return `${year}-${month}-${day}`;
// }

function formatDate(date) {
  if (!date) return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

export default function JournalEntry() {

  const debug = process.env.ENTITY_DEBUG;

  const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_PrimaNota'
  const [intermediari, setIntermediari] = useState({});
  const [intermediarioFilter, setIntermediarioFilter] = useState(0);
  const [{ start, end }] = React.useState(getQuarterDates);
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);

  const filterPayload = { 
    intermediario: intermediarioFilter,
    fromDate: startDate,
    toDate: endDate,
  };

  const remoteDataSource = createStore({
    key: 'id',

    loadUrl: serviceUrl + '/Find',
    
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
          var payload = ajaxOptions.data;
          payload.values = JSON.stringify(filterPayload);
          ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },

  });

  

  const { user} = useAuth(); 

  if (!user) 
    Logout();

    useEffect(() => {
  
      const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      var newUrl7 =  newServiceUrl7 + "/GetIntermediari";
  
      const fetchData = async () => {
        try {

          const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };
          
        const response7 = await fetch(newUrl7,requestOptions);
        const json7 = await response7.json();
        if (debug === 1)
          console.log(json7);
        setIntermediari(json7);
  
  
        } catch (error) {
          console.log("error", error);
        }
      };   
  
      fetchData();
    }, []);

  const onExporting = React.useCallback((e) => {

    const pdfDoc = new jsPDF('l', 'pt', 'a4');


    exportDataGrid({
      jsPDFDocument: pdfDoc,
      component: e.component,
      columnWidths: [50, 100, 70, 70, 260, 60, 60, 60, 60],
      margin: { top: 80, right: 20, bottom: 40, left: 20 },
      customizeCell({ gridCell, pdfCell }) {
        pdfCell.font.size = 7;
      }

    }).then(() => {

      pdfDoc.setFontSize(10);
      const pageCount = pdfDoc.internal.getNumberOfPages();
      for(let i = 1; i <= pageCount; i++) {
        pdfDoc.setPage(i);
        const pageSize = pdfDoc.internal.pageSize;
        const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
        const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        const header = 'Prima nota' ;
        const footer = `Pagina ${i} of ${pageCount}`;

        // Header
        if (i == 1)
        {

          //pdfDoc.text(`Azienda: ${azienda}`, 20, 50);
          pdfDoc.text(`Periodo: ${formatDate(startDate)} - ${formatDate(endDate)}`, 20, 65);
           

          pdfDoc.setFontSize(20);
          pdfDoc.text(header, 20, 25, { baseline: 'top' });
          pdfDoc.setFontSize(10);

          var data = new Date();
          var gg, mm, aaaa;
          gg = data.getDate();
          if (gg < 10) gg = '0' + gg;
          mm = data.getMonth() + 1;
          if (mm < 10) mm = '0' + mm;
          aaaa = data.getFullYear();
          pdfDoc.text('Estrazione del ' + gg + '/' + mm + '/' + aaaa, 680, 60, { baseline: 'top' });
        }
        //pdfDoc.setFontSize(20);
        //pdfDoc.setTextColor(40);
        //pdfDoc.text("Report", 40, 22);

        // Footer
        pdfDoc.setFontSize(8);
        pdfDoc.text(footer, pageWidth / 2 - (pdfDoc.getTextWidth(footer) / 2), pageHeight - 15, { baseline: 'bottom' });


      }
      pdfDoc.save('Primanota.pdf');
    });
  });


  const selectBoxOptions2 = {
    width: 210,
    items: intermediari,
    valueExpr: 'id',
    displayExpr: 'ragioneSociale',
    placeholder:"<Azienda>",
    showClearButton:true,
    onValueChanged: (args) => {
      setIntermediarioFilter(args.value);
    },
    value: intermediarioFilter,
  };

  const startDateValueChanged = (e) => {
    setStartDate(e.value);
  };
  const endDateValueChanged = (e) => {
    setEndDate(e.value);
  };

  function onToolbarPreparing(e) {
    e.toolbarOptions.items.push({
        widget: 'dxButton',
        name: "myexport",
        location: "before",
        options: {
            icon: pdfIcon,
            hint: "Stampa",
            onClick: function() {
              onExporting(e);
            }
        }
    });
  }

  return (
  <React.Fragment>
    <h2 className={'content-block'}>Prima nota</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
      
        <DataGrid
          dataSource={remoteDataSource}
          focusedRowEnabled={true}
          showBorders={true}
          onToolbarPreparing = {onToolbarPreparing}
          onExporting={onExporting}
        >
         <SearchPanel visible={true} width={240} placeholder="Cerca..." />
         
          <Toolbar>
            <Item location="after">
              <div style={{ paddingRight: 8, paddingLeft: 8, fontWeight: 600 }}>
                Periodo:
              </div>
            </Item>
            <Item location="after">
              <DateBox
                value = {startDate}
                showClearButton={false}
                onValueChanged={startDateValueChanged}
              />
            </Item>
            <Item location="after">
              <DateBox
                value = {endDate}
                showClearButton={false}
                onValueChanged={endDateValueChanged}
              />
            </Item>
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions2} >
            </Item>
            <Item name="searchPanel" className="offer-toolbar"/>
          </Toolbar>
        <Selection mode="single" />
        <Editing
          mode="row"
          useIcons={true}
          allowAdding={false}
          allowDeleting={false}
          allowUpdating={false}     
        />
        <Column dataField="id" visible={true} caption="Id" width={80}/>
        <Column dataField="aziendaId" caption="Azienda" width={240} visible={true} >
          <Lookup dataSource={intermediari} valueExpr="id" displayExpr="ragioneSociale" />
        </Column>
        <Column dataField="dataOperazione" dataType="date" format= {'dd/MM/yyyy'} caption="Data Operazione" width={130} />
        <Column dataField="dataDocumento" dataType="date" format= {'dd/MM/yyyy'} caption="Data Documento" width={130} />
        <Column dataField="descrizione" />

      
        <Column dataField="entrateCassa"  visible={true} width={100}>
          <Format type="fixedPoint" precision={2} /> 
        </Column>
          <Column dataField="usciteCassa"  visible={true} width={100}>
          <Format type="fixedPoint" precision={2} /> 
        </Column>
        <Column dataField="entrateBanca"  visible={true} width={100}>
          <Format type="fixedPoint" precision={2} /> 
        </Column>
          <Column dataField="usciteBanca"  visible={true} width={100}>
          <Format type="fixedPoint" precision={2} /> 
        </Column>
      </DataGrid>

      </div>
    </div>
  </React.Fragment>
)};
